<template>
  <div>
    <AddAttachment v-bind:afterdone="filterDataAttachment" v-bind:customer_id="customerId"></AddAttachment>
    <AddTask v-bind:afterdone="filterDataTask" v-bind:customer_id="customerId" v-bind:task_id="task_id"
      v-bind:parent_id="parent_id"></AddTask>
    <AddEvent v-bind:afterdone="filterDataEvent" v-bind:customer_id="customerId" v-bind:event_id="event_id"
      v-bind:task_id="task_id"></AddEvent>
    <AddTag v-bind:afterdone="filterDataTag" v-bind:customer_id="customerId" v-bind:tag_id="tag_id"></AddTag>
    <AddContact v-bind:afterdone="filterDataContact" v-bind:customer_id="customerId" v-bind:contact_id="contact_id">
    </AddContact>
    <b-card>
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="رویدادها" href="#events" @click="
            task_event_id = 0;
          filterDataEvent();
          " :active="$route.hash === '#' || $route.hash === ''">
            <div>
              <b-modal ok-title="جستجو" cancel-title="انصراف" id="modal-1" title="جستجو" @ok="filterDataEvent()">
                <b-form-group id="input-group-2" label="وضعیت: " label-for="input-2">
                  <MDDropdown v-bind:group="107" v-model="search_event.mdid107_type"></MDDropdown>
                </b-form-group>
                <b-col>
                  <b-form-group id="input-group-2" label="تاریخ رویداد" label-for="input-2">
                    <date-picker required v-model="search_event.date_done"></date-picker>
                  </b-form-group>
                </b-col>
              </b-modal>
              <b-card-text>
                <br />
                <b-button class="mt-3" variant="success" @click="
                  event_id = null;
                $bvModal.show('addevent-modal');
                ">جدید</b-button>
                <b-button class="mt-3 ml-3" variant="success" v-b-modal.modal-1>جستجو</b-button>
                <br />
                <br />

                <b-table responsive style="width: 100%" striped hover show-empty empty-text="آیتمی جهت نمایش وجود ندارد"
                  :fields="fields_event" :items="ListEvent">
                  <template v-slot:cell(details)="row">
                    <span>
                      <b-link variant="success" @click="
                        event_id = row.item.id;
                      $bvModal.show('addevent-modal');
                      ">&nbsp;&nbsp;ویرایش&nbsp;</b-link>
                      |
                    </span>
                    <span>
                      <b-link variant="success" @click="deletem('event', row.item.id)">&nbsp;&nbsp;حذف</b-link>
                    </span>
                  </template>
                </b-table>
              </b-card-text>
              <b-modal ref="delete-modal" ok-title="تایید" cancel-title="انصراف" @ok="handleOk" title="حذف">آیا مایل به
                حذف آیتم مورد
                نظر می باشید؟</b-modal>
            </div>
          </b-tab>
          <b-tab title="پیگیری ها" href="#tasks" :active="$route.hash === '#tasks'">
            <div>
              <b-modal ok-title="جستجو" cancel-title="انصراف" id="modal-2" title="جستجو" @ok="filterDataTask()">
                <b-form-group id="input-group-1" label="عنوان: " label-for="input-1">
                  <b-form-input id="input-1" v-model="search_task.title"></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-2" label="نوع پیگیری: " label-for="input-2">
                  <MDDropdown v-bind:group="108" v-model="search_task.mdid108_type"></MDDropdown>
                </b-form-group>
                <b-form-group id="input-group-2" label="الویت: " label-for="input-2">
                  <MDDropdown v-bind:group="109" v-model="search_task.mdid109_type"></MDDropdown>
                </b-form-group>
                <b-col>
                  <b-form-group id="input-group-2" label="تاریخ رویداد" label-for="input-2">
                    <date-picker required v-model="search_task.due_date"></date-picker>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="is_fav-gr" label="وضعیت:" label-for="is_done">
                    <b-form-select v-model="search_task.is_done" :options="is_donis"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-modal>
              <b-card-text>
                <br />
                <b-button class="mt-3" variant="success" @click="
                  task_id = null;
                $bvModal.show('addtask-modal');
                ">جدید</b-button>
                <b-button class="mt-3 ml-3" variant="success" v-b-modal.modal-2>جستجو</b-button>
                <br />
                <br />

                <b-table responsive style="width: 100%" striped hover show-empty empty-text="آیتمی جهت نمایش وجود ندارد"
                  :fields="fields_task" :items="ListTask">
                  <template v-slot:cell(details)="row">
                    <span>
                      <b-link variant="success" @click="
                        task_id = row.item.id;
                      $bvModal.show('addtask-modal');
                      ">&nbsp;&nbsp;ویرایش&nbsp;</b-link>
                      |
                    </span>
                    <span>
                      <b-link variant="success" @click="deletem('task', row.item.id)">&nbsp;&nbsp;حذف</b-link>
                      |
                    </span>
                    <span>
                      <b-link variant="success" @click="
                        task_id = row.item.id;
                      $bvModal.show('addevent-modal');
                      ">&nbsp;&nbsp;رویداد جدید</b-link>
                      |
                    </span>
                    <span>
                      <b-link variant="success" @click="
                        task_event_id = row.item.id;
                      $bvModal.show('listevent-modal');
                      filterDataEvent(task_event_id);
                      ">&nbsp;&nbsp;لیست رویدادها</b-link>
                    </span>
                    <span v-if="row.item.is_done1 == 0">
                      |
                      <b-link variant="success" @click="
                        parent_id = row.item.id;
                      $bvModal.show('addtask-modal');
                      ">&nbsp;&nbsp;انجام شد و ثبت پیگیری جدید</b-link>
                    </span>
                  </template>
                </b-table>
              </b-card-text>
              <b-modal ref="delete-modal" ok-title="تایید" cancel-title="انصراف" @ok="handleOk" title="حذف">آیا مایل به
                حذف آیتم
                مورد نظر می باشید؟</b-modal>
            </div>
          </b-tab>
          <b-tab title="مخاطبین" href="#contacts" :active="$route.hash === '#contacts'">
            <div>
              <b-modal ok-title="جستجو" cancel-title="انصراف" id="modal-7" title="جستجو" @ok="filterDataContact()">
                <b-form-group id="input-group-1" label="نام: " label-for="input-1">
                  <b-form-input id="input-1" v-model="search_contact.name"></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-1" label="موبایل 1: " label-for="input-1">
                  <b-form-input id="input-1" v-model="search_contact.mobile1"></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-1" label="موبایل 2: " label-for="input-1">
                  <b-form-input id="input-1" v-model="search_contact.mobile2"></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-1" label="ایمیل: " label-for="input-1">
                  <b-form-input id="input-1" v-model="search_contact.email"></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-1" label="تلفن: " label-for="input-1">
                  <b-form-input id="input-1" v-model="search_contact.phone"></b-form-input>
                </b-form-group>
              </b-modal>
              <b-card-text>
                <br />
                <b-button class="mt-3" variant="success" @click="
                  task_id = null;
                $bvModal.show('addcontact-modal');
                ">جدید</b-button>
                <b-button class="mt-3 ml-3" variant="success" v-b-modal.modal-7>جستجو</b-button>
                <br />
                <br />

                <b-table responsive style="width: 100%" striped hover show-empty empty-text="آیتمی جهت نمایش وجود ندارد"
                  :fields="fields_contact" :items="ListContact">
                  <template v-slot:cell(details)="row">
                    <span>
                      <b-link variant="success" @click="
                        contact_id = row.item.id;
                      $bvModal.show('addcontact-modal');
                      ">&nbsp;&nbsp;ویرایش&nbsp;</b-link>
                      |
                    </span>
                    <span>
                      <b-link variant="success" @click="deletem('contact', row.item.id)">&nbsp;&nbsp;حذف</b-link>

                    </span>
                  </template>
                </b-table>
              </b-card-text>
              <b-modal ref="delete-modal" ok-title="تایید" cancel-title="انصراف" @ok="handleOk" title="حذف">آیا مایل به
                حذف آیتم
                مورد نظر می باشید؟</b-modal>
            </div>
          </b-tab>
          <b-tab title="پیوست ها" href="#attachment" :active="$route.hash === '#attachment'">
            <div>
              <b-card-text>
                <br />
                <b-button class="mt-3" variant="success" @click="$bvModal.show('addattachment-modal')">جدید</b-button>
                <br />
                <br />
                <b-row>
                  <b-col cols="4" v-for="attachment in ListAttachment" :key="attachment.id">
                    <b-card class="mt-4" :img-src="attachment.fileUrl">
                      <i class="ibl64 ibl-bsi"></i>

                      <div>
                        <p class="text-bold pl-5">
                          {{ attachment.description }}
                        </p>
                      </div>

                      <b-button @click="deletem('attachment', attachment.id)" variant="primary">حذف</b-button>
                    </b-card>
                  </b-col>
                </b-row>
              </b-card-text>
              <b-modal ref="delete-modal" ok-title="تایید" cancel-title="انصراف" @ok="handleOk" title="حذف">آیا مایل به
                حذف آیتم
                مورد نظر می باشید؟</b-modal>
            </div>
          </b-tab>
          <b-tab title="تگ ها" href="#tags" :active="$route.hash === '#tags'">
            <div>
              <b-modal ok-title="جستجو" cancel-title="انصراف" id="modal-4" title="جستجو" @ok="filterDataTag()">
                <b-form-group id="input-group-2" label="تگ: " label-for="input-2">
                  <MDDropdown v-bind:group="111" v-model="search_tag.mdid111_tag"></MDDropdown>
                </b-form-group>
              </b-modal>
              <b-card-text>
                <br />
                <b-button class="mt-3" variant="success" @click="
                  tag_id = null;
                $bvModal.show('addtag-modal');
                ">جدید</b-button>
                <b-button class="mt-3 ml-3" variant="success" v-b-modal.modal-4>جستجو</b-button>
                <br />
                <br />

                <b-table responsive style="width: 100%" striped hover show-empty empty-text="آیتمی جهت نمایش وجود ندارد"
                  :fields="fields_tag" :items="ListTag">
                  <template v-slot:cell(details)="row">
                    <span>
                      <b-link variant="success" @click="
                        tag_id = row.item.id;
                      $bvModal.show('addtag-modal');
                      ">&nbsp;&nbsp;ویرایش&nbsp;</b-link>
                      |
                    </span>
                    <span>
                      <b-link variant="success" @click="deletem('tag', row.item.id)">&nbsp;&nbsp;حذف</b-link>
                    </span>
                  </template>
                </b-table>
              </b-card-text>
              <b-modal ref="delete-modal" ok-title="تایید" cancel-title="انصراف" @ok="handleOk" title="حذف">آیا مایل به
                حذف آیتم
                مورد نظر می باشید؟</b-modal>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
    <b-modal ref="listevent-modal" ok-title="تایید" cancel-title="انصراف" id="listevent-modal" title="لیست رویدادها">
      <b-table responsive style="width: 100%" striped hover show-empty empty-text="آیتمی جهت نمایش وجود ندارد"
        :fields="fields_event" :items="ListEvent">
        <template v-slot:cell(details)="row">
          <span>
            <b-link variant="success" @click="deletem('taskevent', row.item.id)">&nbsp;&nbsp;حذف</b-link>
          </span>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<style>
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";
import fileUploader from "../../components/fileUploader";
import AddAttachment from "./Attachments/AddAttachment";
import AddTask from "./Tasks/AddTask";
import AddEvent from "./Events/AddEvent";
import AddTag from "./Tags/AddTag";
import AddContact from "./Contacts/AddContact";
import routesMap from "@/helpers/routesMap"
export default {
  name: "CustomerDetail",
  data: function () {
    return {
      ListTag: [],
      ListEvent: [],
      ListTask: [],
      ListContact: [],
      ListAttachment: [],
      customerId: 0,
      task_id: 0,
      contact_id: 0,
      event_id: 0,
      tag_id: 0,
      parent_id: 0,
      task_event_id: 0,
      fields_tag: [
        {
          key: "id",
          label: "شماره",
        },
        {
          key: "mdid111_tag",
          label: "تگ",
        },
        {
          key: "metadata_parent",
          label: "گروه",
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      fields_event: [
        {
          key: "id",
          label: "شماره",
        },
        {
          key: "mdid107_type",
          label: "نوع رویداد",
        },
        {
          key: "date_done",
          label: "تاریخ رویداد",
        },
        {
          key: "time_done",
          label: "ساعت رویداد",
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      fields_task: [
        {
          key: "id",
          label: "شماره",
        },
        {
          key: "title",
          label: "عنوان",
        },
        {
          key: "parent_name",
          label: "رویداد مربوطه ",
        },
        {
          key: "mdid108_type",
          label: "نوع پیگیری",
        },
        {
          key: "mdid109_type",
          label: "الویت",
        },
        {
          key: "due_date",
          label: "تاریخ ",
        },
        {
          key: "due_time",
          label: "ساعت ",
        },
        {
          key: "is_done",
          label: "وضعیت ",
        },

        {
          key: "details",
          label: "جزییات",
        },
      ],
      fields_contact: [
        {
          key: "id",
          label: "شماره",
        },
        {
          key: "name",
          label: "نام",
        },
        {
          key: "mobile1",
          label: "موبایل 1",
        },
        {
          key: "mobile2",
          label: "موبایل 2",
        },
        {
          key: "phone",
          label: "تلفن",
        },
        {
          key: "email",
          label: "ایمیل ",
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      fields_attachment: [
        {
          key: "id",
          label: "شماره",
        },
        {
          key: "created_at",
          label: "تاریخ",
        },
        {
          key: "description",
          label: "توضیحات",
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      selected_item: 0,
      selected_item: "",
      search_event: {
        mdid107_type: 0,
        date_done: null,
      },
      search_tag: {
        mdid111_tag: 0,
      },
      search_task: {
        title: null,
        mdid108_type: 0,
        mdid109_type: 0,
        due_date: null,
        is_done: null,
      },
      search_contact: {
        name: null,
        mobile1: null,
        mobile2: null,
        phone: null,
        email: null,
      },
      is_donis: [
        {
          value: 0,
          text: "انجام نشده",
        },
        {
          value: 1,
          text: "انجام شده",
        },
      ],
      routesMap,
    };
  },
  components: {
    MDDropdown,
    persianDate,
    fileUploader,
    AddAttachment,
    AddTask,
    AddContact,
    AddEvent,
    AddTag,
  },
  created() {
    this.filterDataEvent();
    this.filterDataTag();
    this.filterDataTask();
    this.filterDataContact();
    this.filterDataAttachment();
  },
  methods: {
    handleOk: function () {
      if (this.selectType == "event") {
        httpHelper.getData("crmevents/" + this.selected_item).then((res) => {
          if (res.success) {
            //this.List.splice(this.List.indexOf(this.selected_item), 1);
            this.filterDataEvent();
          }
        });
      }
      if (this.selectType == "taskevent") {
        httpHelper.getData("crmevents/" + this.selected_item).then((res) => {
          if (res.success) {
            //this.List.splice(this.List.indexOf(this.selected_item), 1);
            this.filterDataEvent(this.task_event_id);
          }
        });
      }
      if (this.selectType == "tag") {
        httpHelper.getData("crmtags/" + this.selected_item).then((res) => {
          if (res.success) {
            //this.List.splice(this.List.indexOf(this.selected_item), 1);
            this.filterDataTag();
          }
        });
      } else if (this.selectType == "attachment") {
        httpHelper
          .getData("crmattachment/" + this.selected_item)
          .then((res) => {
            if (res.success) {
              //this.List.splice(this.List.indexOf(this.selected_item), 1);
              this.filterDataAttachment();
            }
          });
      } else if (this.selectType == "contact") {
        httpHelper.getData("crmcontacts/" + this.selected_item).then((res) => {
          if (res.success) {
            //this.List.splice(this.List.indexOf(this.selected_item), 1);
            this.filterDataContact();
          }
        });
      } else {
        httpHelper.getData("crmtasks/" + this.selected_item).then((res) => {
          if (res.success) {
            //this.List.splice(this.List.indexOf(this.selected_item), 1);
            this.filterDataEvent();
          }
        });
      }
    },
    deletem: function (selectType, selectedItem) {
      this.selected_item = selectedItem;
      this.selectType = selectType;
      this.$refs["delete-modal"].show();
    },
    filterDataEvent: function (task_event_id = 0) {
      this.event_id = null;
      var params = "";
      this.ListEvent = [];
      if (this.search_event.mdid107_type) {
        params += "&mdid107_type=" + this.search_event.mdid107_type;
      }
      if (task_event_id != 0) {
        params += "&task_id=" + task_event_id;
      } else if (this.task_event_id != 0) {
        params += "&task_id=" + this.task_event_id;
      }
      if (this.search_event.date_done) {
        params += "&date_done=" + this.search_event.date_done;
      }
      httpHelper.setAuth();
      httpHelper
        .getData("crmevents?customer_id=" + this.$route.params.id + params)
        .then((res) => {
          this.ListEvent = res.result.data;
          this.ListEvent = this.ListEvent.map((item) => {
            return {
              id: item.id,
              mdid107_type: item.event_type.title,
              date_done: persianDate.getDateByFormat(item.date_done),
              time_done: persianDate.getTimeWithOutSecend(item.time_done),
              customer_id: item.customer_id,
            };
          });
        })
        .finally(() => { });
    },
    filterDataTag: function () {
      this.tag_id = null;
      var params = "";

      if (this.search_tag.mdid111_tag) {
        params += "&mdid111_tag=" + this.search_tag.mdid111_tag;
      }

      httpHelper.setAuth();
      httpHelper
        .getData("crmtags?customer_id=" + this.$route.params.id + params)
        .then((res) => {
          this.ListTag = res.result.data;
          this.ListTag = this.ListTag.map((item) => {
            return {
              id: item.id,
              mdid111_tag: item.tag.title,
              metadata_parent: item.tag.parent.title,
              customer_id: item.customer_id,
            };
          });
        })
        .finally(() => { });
    },
    filterDataContact: function () {
      var params = "";
      this.contact_id = null;
      if (this.search_contact.name) {
        params += "&name=" + this.search_contact.name;
      }
      if (this.search_contact.mobile1) {
        params += "&mobile1=" + this.search_contact.mobile1;
      }
      if (this.search_contact.mobile2) {
        params += "&mobile2=" + this.search_contact.mobile2;
      }
      if (this.search_contact.phone) {
        params += "&phone=" + this.search_contact.phone;
      }
      if (this.search_contact.email) {
        params += "&email=" + this.search_contact.email;
      }
      httpHelper
        .getData("crmcontacts?customer_id=" + this.$route.params.id + params)
        .then((res) => {
          this.ListContact = res.result.data;
        })
        .finally(() => { });
    },
    filterDataTask: function () {
      var params = "";
      this.task_id = null;
      if (this.search_task.mdid108_type) {
        params += "&mdid108_type=" + this.search_task.mdid108_type;
      }
      if (this.search_task.mdid109_type) {
        params += "&mdid109_type=" + this.search_task.mdid109_type;
      }
      if (this.search_task.title) {
        params += "&title=" + this.search_task.title;
      }
      if (this.search_task.due_date) {
        params += "&due_date=" + this.search_task.due_date;
      }
      if (this.search_task.is_done == 0 || this.search_task.is_done == 1) {
        params += "&is_done=" + this.search_task.is_done;
      }
      httpHelper
        .getData("crmtasks?customer_id=" + this.$route.params.id + params)
        .then((res) => {
          this.ListTask = res.result.data;
          this.ListTask = this.ListTask.map((item) => {
            return {
              id: item.id,
              title: item.title,
              mdid108_type: item.follow_type.title,
              mdid109_type: item.priority_type.title,
              due_date: persianDate.getDateByFormat(item.due_date),
              due_time: persianDate.getTimeWithOutSecend(item.due_time),
              is_done1: item.is_done,
              is_done: item.is_done == 1 ? "انجام شده" : "انجام نشده",
              customer_id: item.customer_id,
              parent_name: item.parent_id != null ? item.parent.title + "(" + item.parent.id + ")" : "-"
            };
          });
        })
        .finally(() => { });
    },
    filterDataAttachment: async function () {
      try {
        const res = await httpHelper.getData(
          "crmattachment?customer_id=" + this.$route.params.id
        );
        const attachments = res.result.data;
        this.ListAttachment = await Promise.all(
          attachments.map(async (item) => {
            const fileUrl = await httpHelper.getImage(item.file_id);
            return {
              id: item.id,
              file_id: item.file_id,
              description: item.description,
              created_at: persianDate.getDateByFormat(item.created_at),
              customer_id: item.customer_id,
              fileUrl: fileUrl,
            };
          })
        );
      } catch {
        console.error("Error loading attachments:", err);
      }
    },
  },
  mounted() {
    if (this.$route.params.id != null) {
      this.customerId = this.$route.params.id;
    }

    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست بازاریابی",
        route: "/Customers",
      },
      {
        title: "جزییات مشتری",
      },
    ]);
  },
};
</script>
